module.exports = {
  src: __webpack_public_path__ + "logo-insegnia-Italia-f1943d581f1ca2750096050f891b7cee.svg",
  width: 61,
  height: 97,
  bytes: 47093,
  type: "svg",
};
module.exports.toString = function() {
  return __webpack_public_path__ + "logo-insegnia-Italia-f1943d581f1ca2750096050f891b7cee.svg";
};